<template>
  <div class="page">
    <div class="fixed-top bg-white">
      <div>
        <van-search
            v-model.trim="keyword"
            show-action
            placeholder="用户昵称/申请名称/手机号/微信号">
          <div slot="action" @click="onOrderKeywordActionSheetChange(keyword)">搜索</div>
        </van-search>
      </div>
      <div class="flex justify-around" style="color: black ;">
        <!--   状态选择   -->
        <div class="toolbar van-hairline--bottom">
          <div class="tool-item btn-select-sort flex" style="align-items: center;" @click="orderTypeActionSheet.show = true" >
            <span v-if="orderTypeName=='全部'">状态&nbsp;</span>
            <span v-else style="vertical-align:top;">{{orderTypeName}} &nbsp;</span>
            <van-icon size="16px" name="arrow-down"/>
            <span class="caret"></span></div>
        </div>
        <!--   性别选择   -->
        <div class="toolbar van-hairline--bottom">
          <div class="tool-item btn-select-sort flex" style="align-items: center;" @click="orderSexActionSheet.show = true">
<!--            <span>性别:</span>-->
            <span v-if="orderTypeSex=='全部'">性别&nbsp;</span>
            <span v-else>{{ orderTypeSex }} &nbsp;</span>
            <van-icon size="16px" name="arrow-down" />
            <span class="caret"></span></div>
        </div>
      </div>
    </div>

    <van-list
        v-model="loading"
        :finished="listFinished"
        finished-text="没有更多了"
        @load="loadData">
      <van-cell-group class="order-list">
        <van-cell v-for="(item, index) in list" :key="index" :to="'/guilder/clerk-apply/detail/'+ item.id" center clickable
                  size="large">
          <div style="display: flex; flex-direction: row;justify-content: space-between">
            <div style="display: flex;flex-direction: row">
              <!--头像-->
              <div>
                <img :src="item.userAvatar" height="50" style="border-radius: 50%;display: block" width="50"/>
              </div>
              <div style="display: flex;flex-direction: column; margin-left: 10px">
                <div style="white-space: nowrap;display: flex;">
<!--                  <span style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;max-width: 120px" >一二三四五六七八九十</span>-->
                  <span style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;max-width: 120px" >{{ item.userNickName }}</span>
                  <span style="margin-left: 5px">
                    <van-tag v-if="$hasFeature('user_violation_share') && item.violationCount > 0" plain color="#91d5ff" >
                      <a @click.stop.prevent="lookViolation(item.userId)">{{item.violationCount}}条违规</a>
                    </van-tag>
                  </span>
                  <span  style="margin-left: 5px" v-if="$hasFeature('multiple_shop_clerk')">
                    <van-tag v-if="item.otherShop" plain color="orange">
                      <a @click.stop.prevent="showOtherShop(item.otherShop)">{{item.otherShop.length}}条串店</a>
                    </van-tag>
                  </span>
                </div>
                <div style="font-size: small">
                  <span>{{ $store.state.ClerkSexEnum.getLabel(item.sex) }}</span>
                  <span style="margin-left: 10px;color: lightgrey">|</span>
                  <span style="margin-left: 10px">{{ item.regionNames.join('-') }}</span>
                </div>
                <div>
                  <span v-if="item.disGroupName || item.disClerkName" style="font-size: 11px;color: red;">
                    <span v-if="item.disGroupName">推荐：{{item.disGroupName + '|' + item.disClerkName}}</span>
                    <span v-else>推荐：{{item.disClerkName != null ? '店员：' + item.disClerkName : '无'}}</span>
                  </span>
                </div>
              </div>
            </div>
            <div style="display: flex;align-items: center;flex-direction: column" >
              <div>
                <van-tag v-if="item.checkStatus == 0"  plain type="warning" >待审核</van-tag>
                <van-tag v-if="item.checkStatus == 1" plain type="success" >已通过</van-tag>
                <van-tag v-if="item.checkStatus == -1" plain >未通过</van-tag>
                <van-tag v-if="item.checkStatus == 2" plain type="danger" >待验证</van-tag>
                <van-tag v-if="item.checkStatus == 3" type="success" >已成为店员</van-tag>
              </div>
              <div>
                <span style="color: grey">{{ formatDate(item.createTime, 'MM-DD HH:mm') }}</span>
              </div>
            </div>
          </div>

          <!--          <div style="display: flex;">-->
          <!--            <div v-for="(photo,index) in item.photoUrls" :key="index" style="margin-right: 10px">-->
          <!--              <img width="50" height="50" :src="photo" style="border-radius: 5px"/>-->
          <!--            </div>-->

          <!--          </div>-->

        </van-cell>
      </van-cell-group>
    </van-list>

    <!--  查看违规内容  -->
    <ViolationSelect :showViolation="showViolation" :userViolationSignList="violationList"
                     @changeShowViolation="changeShowViolation"></ViolationSelect>

    <OtherShopDialog v-model="showOtherShopDialog" :other-shop="otherShop" @changeShowOtherShop="showOtherShopDialog=false" />
    <!--上拉选择订单类型-->
    <van-action-sheet
        v-model="orderTypeActionSheet.show"
        :actions="orderTypeActionSheet.actions"
        cancel-text="取消"
        @select="onOrderTypeActionSheetChange"/>

    <!--上拉选择性别-->
    <van-action-sheet
        v-model="orderSexActionSheet.show"
        :actions="orderSexActionSheet.actions"
        cancel-text="取消"
        @select="onOrderSexActionSheetChange"/>

  </div>
</template>

<script>
import Vue from 'vue';
import {ActionSheet, Button, Cell, CellGroup, Dialog, Icon, List, Panel, Search, Tab, Tabs, Tag} from 'vant';
import {getClerkApplyList} from '@/api/guilder/clerk_apply'
import { lookViolation} from '@/api/user'
import moment from 'moment';
import Decimal from 'decimal.js';
import ViolationSelect from '@/components/common/violation-select'
import OtherShopDialog from "@/components/common/other-shop-dialog";

Vue.use(Tab)
    .use(Tabs)
    .use(Search)
    .use(Button)
    .use(List)
    .use(Cell)
    .use(CellGroup)
    .use(Tag)
    .use(Icon)
    .use(ActionSheet)
    .use(Dialog)
    .use(Panel)

export default {
  name: 'clerk-apply-list',
  components:{
    ViolationSelect,
    OtherShopDialog
  },
  data() {
    return {
      keyword:null,
      showViolation: false,
      violationList: [],
      showOtherShopDialog: false,
      otherShop: [],
      status: null,
      sex: null,
      serviceType: null,
      orderTypeActionSheet: {
        show: false,
        actions: [
          {name: '全部', value: null},
          {name: '待审核', value: 0},
          {name: '已通过', value: 1},
          {name: '未通过', value: -1},
          {name: '待验证', value: 2},
          {name: '已成为店员', value: 3}
        ]
      },
      orderSexActionSheet: {
        show: false,
        actions: [
          {name: '全部', value: null},
          {name: '男', value: 1},
          {name: '女', value: 2}
        ]
      },
      serviceTypeActionSheet: {
        show: false,
        actions: []
      },
      list: [],
      loading: false,
      listFinished: false,
      pageNo: 1,
      pageSize: 10
    }
  },
  computed: {
    orderTypeName() {
      if (this.status == 0) {
        return "待审核"
      }
      if (this.status == 1) {
        return "已通过"
      }
      if (this.status == -1) {
        return "未通过"
      }
      if (this.status == 2) {
        return "待验证"
      }
      if (this.status == 3) {
        return "已成为店员"
      }
      return "全部"
    },
    orderTypeSex() {
      if (this.sex == 1) {
        return "男"
      }
      if (this.sex == 2) {
        return "女"
      }
      return "全部"
    }
  },
  methods: {
    changeShowViolation(val){
      this.showViolation = val
    },
    formatDate(date, format) {
      if (!date) {
        return '';
      }
      if (!format) {
        format = 'YYYY-MM-DD'
      }
      return moment(date).format(format);
    },
    formatPrice(price) {
      if (price != null) {
        return Decimal.div(price, 100).toString()
      }
      return ''
    },
    onOrderTypeActionSheetChange(item) {
      this.status = item.value
      this.orderTypeActionSheet.show = false
      this.loadData(true)
    },
    onOrderSexActionSheetChange(item) {
      this.sex = item.value
      this.orderSexActionSheet.show = false
      this.loadData(true)
    },
    onOrderKeywordActionSheetChange(item) {
      this.keyword = item
      this.loadData(true)
    },
    loadData(resetFirstPage) {
      // 重置为首页
      if (resetFirstPage) {
        this.pageNo = 1
      }
      // 清空数据
      if (this.pageNo == 1) {
        this.list = [];
      }
      this.loading = true
      getClerkApplyList(this.status, this.sex,this.keyword, this.pageNo, this.pageSize).then(res => {
        this.loading = false
        const data = res.data;
        if (data.code == 0) {
          this.list = this.list.concat(data.list)
          if (data.hasNextPage) {
            this.listFinished = false
          } else {
            this.listFinished = true
          }
        } else {
          this.listFinished = true
          Dialog.alert({
            title: '加载失败',
            message: data.msg
          })
        }
        this.pageNo++
      })
    },
    lookViolation(userId) {
      this.showViolation = true
      lookViolation(userId).then(res => {
        const data = res.data;
        if (data.code == 0) {
          this.violationList = data.violationList
        } else {
          Dialog.alert({
            title: '加载失败',
            message: data.msg
          })
        }
      })
    },
    showOtherShop(otherShop){
      this.otherShop = otherShop;
      this.showOtherShopDialog = true;
    }
  },
  mounted() {
  },
  updated() {
    // 统一替换标签
    this.$replaceLabel(document.body, this.$store.state.label, true)
  }
}
</script>

<style lang="less" scoped>

.page {
  padding-top: 95px;
  padding-bottom: 100px;
}

.fixed-top {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;

  .toolbar {
    height: 44px;
    font-size: 14px;
    background: #fff;
    position: relative;
    display: flex;

    .tool-item {
      position: relative;
      padding: 12px 0;
      text-align: center;
      flex: 1;
    }
  }
}

.fixed-top-next {
  position: fixed;
  top: 45px;
  left: 0;
  right: 0;
  z-index: 1000;

  .toolbar {
    height: 44px;
    font-size: 14px;
    background: #fff;
    position: relative;
    display: flex;

    .tool-item {
      position: relative;
      padding: 12px 0;
      text-align: center;
      flex: 1;
    }
  }
}

.order-item {
  display: flex;
  align-items: center;

  .userMemo {
    color: #999;
  }

  .left {
    flex: 1;

    .service-info {
      color: #333;
    }

    .created {
      color: #555;
      margin-bottom: 5px;
    }
  }

  .right {
    text-align: right;
    min-width: 30px;

    .total-amount {
      color: #333;
    }
  }
}

</style>
